import Vue from 'vue';
import ElementUI from 'element-ui';
import Rx from 'rxjs/Rx';
import VueRx from 'vue-rx';
import '@/icons'; // icon
import locale from 'element-ui/lib/locale/lang/zh-CN';
import action from '@/directives/action';
import watermark from '@/directives/watermark';
import 'nprogress/nprogress.css';
import mixin from '@/mixin';
import App from './App';
import router from './router';
import './fonts/iconfont.css';

Vue.use(ElementUI, { locale, size: 'mini' });
Vue.use(VueRx, Rx);

Vue.config.productionTip = false;
Vue.directive('action', action);
Vue.directive('watermark', watermark);
Vue.mixin(mixin);

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});

/* eslint-disable no-undef */
// 版本标识
window.APP_BUILD_TIME = APP_BUILD_TIME;



// WEBPACK FOOTER //
// ./src/main.js